export type CountryOption = { code: string; name: string }

export const COUNTRIES: CountryOption[] = [
  { code: 'af', name: 'Afeganistão' },
  { code: 'za', name: 'África do Sul' },
  { code: 'al', name: 'Albânia' },
  { code: 'de', name: 'Alemanha' },
  { code: 'ad', name: 'Andorra' },
  { code: 'ao', name: 'Angola' },
  { code: 'ai', name: 'Anguila' },
  { code: 'aq', name: 'Antártida' },
  { code: 'ag', name: 'Antígua e Barbuda' },
  { code: 'sa', name: 'Arábia Saudita' },
  { code: 'dz', name: 'Argélia' },
  { code: 'ar', name: 'Argentina' },
  { code: 'am', name: 'Armênia' },
  { code: 'aw', name: 'Aruba' },
  { code: 'au', name: 'Austrália' },
  { code: 'at', name: 'Áustria' },
  { code: 'az', name: 'Azerbaijão' },
  { code: 'bs', name: 'Bahamas' },
  { code: 'bh', name: 'Bahrein' },
  { code: 'bd', name: 'Bangladesh' },
  { code: 'bb', name: 'Barbados' },
  { code: 'be', name: 'Bélgica' },
  { code: 'bz', name: 'Belize' },
  { code: 'bj', name: 'Benim' },
  { code: 'bm', name: 'Bermudas' },
  { code: 'by', name: 'Bielorrússia' },
  { code: 'bo', name: 'Bolívia' },
  { code: 'ba', name: 'Bósnia e Herzegovina' },
  { code: 'bw', name: 'Botsuana' },
  { code: 'br', name: 'Brasil' },
  { code: 'bn', name: 'Brunei' },
  { code: 'bg', name: 'Bulgária' },
  { code: 'bf', name: 'Burquina Faso' },
  { code: 'bi', name: 'Burundi' },
  { code: 'bt', name: 'Butão' },
  { code: 'cv', name: 'Cabo Verde' },
  { code: 'cm', name: 'Camarões' },
  { code: 'kh', name: 'Camboja' },
  { code: 'ca', name: 'Canadá' },
  { code: 'qa', name: 'Catar' },
  { code: 'kz', name: 'Cazaquistão' },
  { code: 'td', name: 'Chade' },
  { code: 'cl', name: 'Chile' },
  { code: 'cn', name: 'China' },
  { code: 'cy', name: 'Chipre' },
  { code: 'co', name: 'Colômbia' },
  { code: 'km', name: 'Comores' },
  { code: 'cg', name: 'Congo' },
  { code: 'cd', name: 'Congo (RDC)' },
  { code: 'kp', name: 'Coreia do Norte' },
  { code: 'kr', name: 'Coreia do Sul' },
  { code: 'ci', name: 'Costa do Marfim' },
  { code: 'cr', name: 'Costa Rica' },
  { code: 'hr', name: 'Croácia' },
  { code: 'cu', name: 'Cuba' },
  { code: 'cw', name: 'Curaçao' },
  { code: 'dk', name: 'Dinamarca' },
  { code: 'dj', name: 'Djibuti' },
  { code: 'dm', name: 'Dominica' },
  { code: 'eg', name: 'Egito' },
  { code: 'sv', name: 'El Salvador' },
  { code: 'ae', name: 'Emirados Árabes Unidos' },
  { code: 'ec', name: 'Equador' },
  { code: 'er', name: 'Eritreia' },
  { code: 'sk', name: 'Eslováquia' },
  { code: 'si', name: 'Eslovênia' },
  { code: 'es', name: 'Espanha' },
  { code: 'us', name: 'Estados Unidos' },
  { code: 'ee', name: 'Estônia' },
  { code: 'sz', name: 'Essuatíni' },
  { code: 'et', name: 'Etiópia' },
  { code: 'fj', name: 'Fiji' },
  { code: 'ph', name: 'Filipinas' },
  { code: 'fi', name: 'Finlândia' },
  { code: 'fr', name: 'França' },
  { code: 'ga', name: 'Gabão' },
  { code: 'gm', name: 'Gâmbia' },
  { code: 'gh', name: 'Gana' },
  { code: 'ge', name: 'Geórgia' },
  { code: 'gi', name: 'Gibraltar' },
  { code: 'gd', name: 'Granada' },
  { code: 'gr', name: 'Grécia' },
  { code: 'gl', name: 'Groenlândia' },
  { code: 'gp', name: 'Guadalupe' },
  { code: 'gu', name: 'Guam' },
  { code: 'gt', name: 'Guatemala' },
  { code: 'gg', name: 'Guernsey' },
  { code: 'gy', name: 'Guiana' },
  { code: 'gf', name: 'Guiana Francesa' },
  { code: 'gn', name: 'Guiné' },
  { code: 'gq', name: 'Guiné Equatorial' },
  { code: 'gw', name: 'Guiné-Bissau' },
  { code: 'ht', name: 'Haiti' },
  { code: 'nl', name: 'Holanda' },
  { code: 'hn', name: 'Honduras' },
  { code: 'hk', name: 'Hong Kong' },
  { code: 'hu', name: 'Hungria' },
  { code: 'ye', name: 'Iêmen' },
  { code: 'ky', name: 'Ilhas Cayman' },
  { code: 'cx', name: 'Ilha Christmas' },
  { code: 'cc', name: 'Ilhas Cocos' },
  { code: 'ck', name: 'Ilhas Cook' },
  { code: 'fo', name: 'Ilhas Faroé' },
  { code: 'fk', name: 'Ilhas Malvinas' },
  { code: 'mp', name: 'Ilhas Marianas do Norte' },
  { code: 'mh', name: 'Ilhas Marshall' },
  { code: 'pn', name: 'Ilhas Pitcairn' },
  { code: 'sb', name: 'Ilhas Salomão' },
  { code: 'tc', name: 'Ilhas Turcas e Caicos' },
  { code: 'vg', name: 'Ilhas Virgens Britânicas' },
  { code: 'vi', name: 'Ilhas Virgens Americanas' },
  { code: 'in', name: 'Índia' },
  { code: 'id', name: 'Indonésia' },
  { code: 'ir', name: 'Irã' },
  { code: 'iq', name: 'Iraque' },
  { code: 'ie', name: 'Irlanda' },
  { code: 'is', name: 'Islândia' },
  { code: 'il', name: 'Israel' },
  { code: 'it', name: 'Itália' },
  { code: 'jm', name: 'Jamaica' },
  { code: 'jp', name: 'Japão' },
  { code: 'je', name: 'Jersey' },
  { code: 'jo', name: 'Jordânia' },
  { code: 'kw', name: 'Kuwait' },
  { code: 'la', name: 'Laos' },
  { code: 'ls', name: 'Lesoto' },
  { code: 'lv', name: 'Letônia' },
  { code: 'lb', name: 'Líbano' },
  { code: 'lr', name: 'Libéria' },
  { code: 'ly', name: 'Líbia' },
  { code: 'li', name: 'Liechtenstein' },
  { code: 'lt', name: 'Lituânia' },
  { code: 'lu', name: 'Luxemburgo' },
  { code: 'mo', name: 'Macau' },
  { code: 'mk', name: 'Macedônia do Norte' },
  { code: 'mg', name: 'Madagascar' },
  { code: 'my', name: 'Malásia' },
  { code: 'mw', name: 'Malawi' },
  { code: 'mv', name: 'Maldivas' },
  { code: 'ml', name: 'Mali' },
  { code: 'mt', name: 'Malta' },
  { code: 'ma', name: 'Marrocos' },
  { code: 'mq', name: 'Martinica' },
  { code: 'mu', name: 'Maurício' },
  { code: 'mr', name: 'Mauritânia' },
  { code: 'mx', name: 'México' },
  { code: 'mm', name: 'Mianmar' },
  { code: 'fm', name: 'Micronésia' },
  { code: 'mz', name: 'Moçambique' },
  { code: 'md', name: 'Moldávia' },
  { code: 'mc', name: 'Mônaco' },
  { code: 'mn', name: 'Mongólia' },
  { code: 'me', name: 'Montenegro' },
  { code: 'ms', name: 'Montserrat' },
  { code: 'na', name: 'Namíbia' },
  { code: 'nr', name: 'Nauru' },
  { code: 'np', name: 'Nepal' },
  { code: 'ni', name: 'Nicarágua' },
  { code: 'ne', name: 'Níger' },
  { code: 'ng', name: 'Nigéria' },
  { code: 'nu', name: 'Niue' },
  { code: 'no', name: 'Noruega' },
  { code: 'nc', name: 'Nova Caledônia' },
  { code: 'nz', name: 'Nova Zelândia' },
  { code: 'om', name: 'Omã' },
  { code: 'pw', name: 'Palau' },
  { code: 'ps', name: 'Palestina' },
  { code: 'pa', name: 'Panamá' },
  { code: 'pg', name: 'Papua-Nova Guiné' },
  { code: 'pk', name: 'Paquistão' },
  { code: 'py', name: 'Paraguai' },
  { code: 'pe', name: 'Peru' },
  { code: 'pf', name: 'Polinésia Francesa' },
  { code: 'pl', name: 'Polônia' },
  { code: 'pr', name: 'Porto Rico' },
  { code: 'pt', name: 'Portugal' },
  { code: 'ke', name: 'Quênia' },
  { code: 'kg', name: 'Quirguistão' },
  { code: 'ki', name: 'Quiribati' },
  { code: 'gb', name: 'Reino Unido' },
  { code: 'cf', name: 'República Centro-Africana' },
  { code: 'do', name: 'República Dominicana' },
  { code: 're', name: 'Reunião' },
  { code: 'ro', name: 'Romênia' },
  { code: 'rw', name: 'Ruanda' },
  { code: 'ru', name: 'Rússia' },
  { code: 'eh', name: 'Saara Ocidental' },
  { code: 'pm', name: 'São Pedro e Miquelão' },
  { code: 'as', name: 'Samoa Americana' },
  { code: 'ws', name: 'Samoa' },
  { code: 'sm', name: 'San Marino' },
  { code: 'sh', name: 'Santa Helena' },
  { code: 'lc', name: 'Santa Lúcia' },
  { code: 'bl', name: 'São Bartolomeu' },
  { code: 'kn', name: 'São Cristóvão e Nevis' },
  { code: 'mf', name: 'São Martinho' },
  { code: 'st', name: 'São Tomé e Príncipe' },
  { code: 'vc', name: 'São Vicente e Granadinas' },
  { code: 'sn', name: 'Senegal' },
  { code: 'sl', name: 'Serra Leoa' },
  { code: 'rs', name: 'Sérvia' },
  { code: 'sc', name: 'Seicheles' },
  { code: 'sg', name: 'Singapura' },
  { code: 'sx', name: 'Sint Maarten' },
  { code: 'sy', name: 'Síria' },
  { code: 'so', name: 'Somália' },
  { code: 'lk', name: 'Sri Lanka' },
  { code: 'sd', name: 'Sudão' },
  { code: 'ss', name: 'Sudão do Sul' },
  { code: 'se', name: 'Suécia' },
  { code: 'ch', name: 'Suíça' },
  { code: 'sr', name: 'Suriname' },
  { code: 'tj', name: 'Tadjiquistão' },
  { code: 'th', name: 'Tailândia' },
  { code: 'tw', name: 'Taiwan' },
  { code: 'tz', name: 'Tanzânia' },
  { code: 'cz', name: 'Tchéquia' },
  { code: 'tl', name: 'Timor-Leste' },
  { code: 'tg', name: 'Togo' },
  { code: 'tk', name: 'Tokelau' },
  { code: 'to', name: 'Tonga' },
  { code: 'tt', name: 'Trinidad e Tobago' },
  { code: 'tn', name: 'Tunísia' },
  { code: 'tm', name: 'Turcomenistão' },
  { code: 'tr', name: 'Turquia' },
  { code: 'tv', name: 'Tuvalu' },
  { code: 'ua', name: 'Ucrânia' },
  { code: 'ug', name: 'Uganda' },
  { code: 'uy', name: 'Uruguai' },
  { code: 'uz', name: 'Uzbequistão' },
  { code: 'vu', name: 'Vanuatu' },
  { code: 'va', name: 'Vaticano' },
  { code: 've', name: 'Venezuela' },
  { code: 'vn', name: 'Vietnã' },
  { code: 'zm', name: 'Zâmbia' },
  { code: 'zw', name: 'Zimbábue' }
]
